import { notification } from 'antd';

export const handleMessageError = (error: any, t: any, noConvertName?: boolean) => {
    const status = error?.status;
    if (status >= 500) {
        notification.error({
            message: t('common:ERROR'),
            description: t('validateMessage:ERROR_500'),
        });
        return;
    }

    if (status === 403) {
        notification.error({
            message: t('validateMessage:ERROR_403'),
        });
        return;
    }

    const typeMessage = JSON.parse(error?.data?.message) || {};

    // Cannot delete ${feeTypeNames} fee type while ${customerTypeNames} in use

    notification.error({
        message: t('common:ERROR'),
        description: `${t(`validateMessage:${typeMessage.type}`, {
            ...(typeMessage.line && { line: `${typeMessage.line}` }),
            ...(typeMessage.field && {
                name: noConvertName ? typeMessage.field : t(`validateName:${typeMessage.field}`),
            }),
            ...(typeMessage.maxlength && { maxlength: `${typeMessage.maxlength}` }),
            ...(typeMessage.minValue && { minValue: `${typeMessage.minValue}` }),
            ...(typeMessage?.data?.name && { dataError: `${typeMessage.data.name}` }),
        })}`,
    });
};
